/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TravelineCityDto } from './traveline-city-dto';
import {
    TravelineCityDtoFromJSON,
    TravelineCityDtoFromJSONTyped,
    TravelineCityDtoToJSON,
    TravelineCityDtoToJSONTyped,
} from './traveline-city-dto';

/**
 * Список городов
 * @export
 * @interface TravelineCititesResponseDto
 */
export interface TravelineCititesResponseDto {
    /**
     * Список городов
     * @type {Array<TravelineCityDto>}
     * @memberof TravelineCititesResponseDto
     */
    cities: Array<TravelineCityDto>;
}

/**
 * Check if a given object implements the TravelineCititesResponseDto interface.
 */
export function instanceOfTravelineCititesResponseDto(value: object): value is TravelineCititesResponseDto {
    if (!('cities' in value) || value['cities'] === undefined) return false;
    return true;
}

export function TravelineCititesResponseDtoFromJSON(json: any): TravelineCititesResponseDto {
    return TravelineCititesResponseDtoFromJSONTyped(json, false);
}

export function TravelineCititesResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineCititesResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'cities': ((json['cities'] as Array<any>).map(TravelineCityDtoFromJSON)),
    };
}

  export function TravelineCititesResponseDtoToJSON(json: any): TravelineCititesResponseDto {
      return TravelineCititesResponseDtoToJSONTyped(json, false);
  }

  export function TravelineCititesResponseDtoToJSONTyped(value?: TravelineCititesResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'cities': ((value['cities'] as Array<any>).map(TravelineCityDtoToJSON)),
    };
}

